export default "__VITE_ASSET__WEqli9MH__"